$(document).ready(function () {
  // id^="1_kyc_document" means an id which starts with 1_kyc_document
  const kyc2 = $('[id^="1_kyc_document"]');
  const kyc3 = $('[id^="2_kyc_document"]');
  const kyc4 = $('[id^="3_kyc_document"]');

  // id*="file_3_kyc_document" means an id which contains file_3_kyc_document
  const kyc4File = $('[id*="file_3_kyc_document"]')[0];
  const kyc3File = $('[id*="file_2_kyc_document"]')[0];
  const kyc2File = $('[id*="file_1_kyc_document"]')[0];
  const kyc1File = $('[id*="file_0_kyc_document"]')[0];

  const add_button = $('#add-button');

  if (kyc4File) {
    add_button.addClass('d-none');
  } else if (kyc3File) {
    kyc4.addClass('d-none');
  } else if (kyc2File) {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
  } else if (kyc1File) {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
    kyc2.addClass('d-none');
  } else {
    kyc4.addClass('d-none');
    kyc3.addClass('d-none');
    kyc2.addClass('d-none');
  }

  add_button.on("click", function() {
    if (!kyc3.hasClass('d-none')) {
      kyc4.removeClass('d-none');
      add_button.addClass('d-none');
    } else if (!kyc2.hasClass('d-none')) {
      kyc3.removeClass('d-none');
    } else {
      kyc2.removeClass('d-none');
    }
  });
});
